import { Button } from '@chain-zen/ui'
import Link from 'next/link'

import { USER_ROUTES } from '../../../constants/routes'

// DirectMessageButton Component
interface DirectMessageButtonProps {
  receiverId: string
}

/**
 * TODO: The button currently does not take the user to a DM.
 */
export const DirectMessageButton = ({ receiverId }: DirectMessageButtonProps) => {
  return (
    <Link href={`${USER_ROUTES.DIRECT_MESSAGES}?chatType=messaging&memberID=${receiverId}`}>
      <Button
        variant="default"
        size="sm"
        className="bg-blue-600 hover:bg-blue-700 text-white hover:text-white text-xs px-3 py-1 h-7"
        onClick={() => console.log('DirectMessage button clicked!', receiverId)}
      >
        Message
      </Button>
    </Link>
  )
}
